import 'angular';
import 'angular-cookies';
import 'angular-css';
import 'angular-route';
import 'angular-sanitize';
import 'angular-uuid';
import 'angular-mocks';

import 'moment';
import 'moment-timezone';
import 'jstz';

import 'ng-device-detector';

import 'babel-polyfill';

import 'owlcarousel-pre/owl-carousel/owl.carousel';

import '@zeitiger/elevatezoom/jquery.elevatezoom';

import '../resource/lib/modernizr.min.js';
import '../resource/lib/foundation.min.js';

import './app.module';
import './app.route';

const loaded = new Set();

const loadAll = (context, expr) => {
    context.keys().forEach(k => {
        if (loaded.has(k) || (expr && !expr.test(k))) {
            return;
        }

        loaded.add(k);

        context(k);
    });
};

const css = require.context('../resource/css', true, /\.css$/);
loadAll(css, /\d\.\d\.\d/); // third party styles
loadAll(css, /googlefonts/);
loadAll(css, /app.foundation/);
loadAll(css, /parent/);
loadAll(css, /modalStyle/);
loadAll(css, /custom.foundation/);

const modules = require.context('./', true, /\.module\.js$/);
loadAll(modules);

const remaining = require.context('./', true, /^(.(?!(app\.bootstrap|module|tests|spec)))*\.js$/);
loadAll(remaining);

// Add our utilities functions to the window scope
Object.assign(window, require('../resource/lib/utilities'));




// WEBPACK FOOTER //
// ./app/app.dependencies.js